export default "__VITE_ASSET__rUCuneae__"